import script from "./footerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./footerSection.vue?vue&type=script&setup=true&lang=js"

import "./footerSection.vue?vue&type=style&index=0&id=52c6e6a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c6e6a3"]])

export default __exports__